/*
 * Copyright (c) 2023. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {Documento} from "./documento-model";
import {ExactSearchFilter, PartialSearchFilter} from "../../basic-entity-back/filters/search-filter";
import {PropertyMap} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {LineaDocumento} from "./linea-documento-model";
import {Pedido} from "../pedidos/pedido.model";

@BasicEntity({
    name: 'Albaran',
    endpoint: 'albarans',
    isPaginated: true,
    acceptsBulkIriSearch: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'codigoAlbaran',
    type: 'Albaran'
})
export class Albaran extends Documento {
    static readonly ESTADOS_ALBARAN = {
        PROVISIONAL: 'Provisional',
        VALIDO: "Válido",
    };

    @BasicProperty({
        name: 'Estado',
        type: PropertyType.Choice(...Object.values(Albaran.ESTADOS_ALBARAN)),
        sortable: true,
        filters: [ExactSearchFilter]
    })
    private _estado;

    @BasicProperty({
        name: 'Código Albarán',
        type: PropertyType.String(),
        filters: [PartialSearchFilter]
    })
    private _codigoAlbaran: string;

    @BasicProperty({
        name: 'Código Paciente',
        type: PropertyType.String()
    })
    private _codigoPaciente: string;

    @BasicProperty({
        name: 'Código Clínico',
        type: PropertyType.String(),
        nullable: true
    })
    private _codigoClinico;

    @BasicProperty({
        name: 'Fecha envío',
        type: PropertyType.Date()
    })
    private _fechaEnvio;

    public static readonly MAP_PEDIDO: PropertyMap = {
        name: 'Pedido',
        type: PropertyType.FutureUri('pedido.model.ts')
    }
    @BasicProperty(Albaran.MAP_PEDIDO)
    private _pedido;

    @BasicProperty({
        name: 'Líneas',
        type: PropertyType.NestedModel(LineaDocumento, 'albaran', NestedBehavior.CreateOnly),
        array: true
    })
    private _lineasAlbaran: LineaDocumento[];

    get estado() {
        return this._estado;
    }

    set estado(value) {
        this._estado = value;
    }

    get codigoAlbaran(): string {
        return this._codigoAlbaran;
    }

    set codigoAlbaran(value: string) {
        this._codigoAlbaran = value;
    }

    get codigoPaciente(): string {
        return this._codigoPaciente;
    }

    set codigoPaciente(value: string) {
        this._codigoPaciente = value;
    }

    get codigoClinico() {
        return this._codigoClinico;
    }

    set codigoClinico(value) {
        this._codigoClinico = value;
    }

    get fechaEnvio() {
        return this._fechaEnvio;
    }

    set fechaEnvio(value) {
        this._fechaEnvio = value;
    }

    get pedido() {
        return this._pedido;
    }

    set pedido(value) {
        this._pedido = value;
    }

    get lineasAlbaran(): LineaDocumento[] {
        return this._lineasAlbaran;
    }

    set lineasAlbaran(value: LineaDocumento[]) {
        this._lineasAlbaran = value;
    }
}


// LineaDocumento.MAP_ALBARAN.type = PropertyType.Uri(Albaran);
